import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

const importArchives = () => import(/* webpackChunkName: "archives" */ './containers/ArchivesContainer');

const ArchivesRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <BundleRoute
      load={importArchives}
      path={`${match.url}`}
    />
  </LoginRequiredContainer>
);

ArchivesRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default ArchivesRoutes;
